import { useDispatch, useSelector } from "react-redux";
import { getOpenedDescription } from "src/modules/activity-log/duck/selectors";
import { openedDescription } from "src/modules/activity-log/duck/actions";
import IconAsButton from "src/components/IconAsButton";

import { ReactComponent as Icon } from "./description.svg";
import { Box } from "@chakra-ui/react";

export default function DescriptionIcon({ onClick }) {
  const dispatch = useDispatch();
  const openedDescriptionBefore = useSelector(getOpenedDescription);

  return (
    <Box position="relative">
      {!openedDescriptionBefore && (
        <Box
          zIndex={1}
          p="4px"
          borderRadius="100%"
          background="warningBase"
          position="absolute"
          right="4px"
          top="4px"
        />
      )}
      <IconAsButton
        onClick={() => {
          dispatch(openedDescription());
          onClick();
        }}
        fill="mediumEmphasis"
        icon={Icon}
        size="20px"
      />
    </Box>
  );
}
